import LegacyRouteRedirect from '@/components/navigation/LegacyRouteRedirect';
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Locations = lazy(() => import('./Locations').then((m) => ({ default: m.Locations })));
const RentalLocations = lazy(() => import('./rental/RentalLocations').then((m) => ({ default: m.RentalLocations })));

/**
 * The Locations routes.
 */
const locationsRoutes: FuseRouteItemType[] = [
	{
		path: 'locations',
		children: [
			{ index: true, element: <LegacyRouteRedirect to="/locations/managed" /> },
			{
				path: 'managed',
				element: <Locations />
			},
			{
				path: 'rental',
				element: <RentalLocations />
			},
			{
				path: 'managed/:locationId',
				element: <Locations />
			}
		]
	}
];

export default locationsRoutes;
